var React = require('react');

function ProductsIcon41Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_57","data-name":"Obszar roboczy 57","transform":"translate(-5.79 -5.67)"},[React.createElement("path",{"id":"Path_393","data-name":"Path 393","d":"M31.41,18.95V11.64L28.45,8.68l-.05-.05L25.44,5.67H14.65l-3,3v.01H28.4V18.95H11.65V8.68h-.01l-3,3v7.27H5.79v2.81H34.21V18.95Z","key":0}),React.createElement("path",{"id":"Path_394","data-name":"Path 394","d":"M20,32.98a8.659,8.659,0,0,1-8.65-8.65H8.65a11.34,11.34,0,1,0,22.68,0h-2.7a8.659,8.659,0,0,1-8.65,8.65Z","key":1}),React.createElement("rect",{"id":"Rectangle_1111","data-name":"Rectangle 1111","width":"10.72","height":"3.01","transform":"translate(14.64 13.36)","key":2})]));
}

ProductsIcon41Inline.defaultProps = {"width":"28.42","height":"30.01","viewBox":"0 0 28.42 30.01"};

module.exports = ProductsIcon41Inline;

ProductsIcon41Inline.default = ProductsIcon41Inline;
